<template>
  <div v-if="numbers && numbers.length" class="numbers-container">
    <div class="numbers__list">
      <div v-for="(item, i) in numbers" :key="i" class="numbers__item">
        <span class="numbers__item-value">
          {{ formatNumber(item) }}
        </span>
        <span class="numbers__item-title">{{ item.description || item.title || "" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumbersComponent",
  props: {
    numbers: Array,
  },
  computed: {
    numberLocale() {
      const lang =
        this.$store &&
        this.$store.state.session &&
        this.$store.state.session.lang;

      return {
        en: "en-US",
        tr: "tr-TR",
        ru: "ru-RU",
      }[lang] || "en-US";
    },
  },

  methods: {
    formatNumber(item) {
      const raw = item && item.number !== undefined
        ? item.number
        : item && item.value !== undefined
          ? item.value
          : 0;

      const value = Number(raw);

      return Number.isFinite(value)
        ? value.toLocaleString(this.numberLocale, { maximumFractionDigits: 0 })
        : "0";
    },
  },
};
</script>

<style lang="stylus">
.numbers {
  &-container {
    display flex
    flex-direction column
    align-items center
    padding 0 15px
  }

  &__list {
    width 100%
    max-width var(--main_width)
    display flex
    flex-flow row wrap
    align-items center
    justify-content center
    gap 24px
  }

  &__item {
    width calc(25% - 24px)
    display flex
    flex-direction column
    align-items center
    justify-content center
    text-align center;
    padding 24px
    border-radius var(--main_radius)
    background var(--white)
    +below(768px) {
      width calc(50% - 24px)
    }
    +below(420px) {
      width 100%
    }

    &-value {
      font-size: 1.5em
      line-height: 32px;
      color: var(--orange-500)
    }
  }
}
</style>
